<template>
  <div
    class="_color"
    :style="colorStyle"
  />
</template>

<script setup>
import colors from 'shared/colors';
import { computed } from 'vue';
import { getColor } from 'shared/lib/color-map';
import { rgbaToHex } from 'shared/lib/color';
import { shadeColor } from 'shared/lib/style';

const props = defineProps({
  color: {
    type: String,
    required: true,
  },
  shade: {
    type: String,
    default: '',
  },
});
const resolvedColor = computed(() => {
  if (props.shade !== '' && colors[props.color]?.[props.shade]) {
    const value = colors[props.color][props.shade];
    return value.startsWith('rgb') ? rgbaToHex(value) : value;
  }
  return getColor(props.color);
});
const colorStyle = computed(() => ({
  backgroundColor: resolvedColor.value,
  height: '1.5rem',
  width: '1.5rem',
  borderRadius: '.3rem',
  border: `1px solid ${shadeColor(resolvedColor.value, -10)}`,
}));
</script>

<style scoped lang="scss">

</style>
